import React from 'react';
import { Container } from '@perxis-auto/ui-kit';

import { ConstructorContainerProps } from './ConstructorContainer.types';

function ConstructorContainer({ style, children, ...props }: ConstructorContainerProps) {
  return (
    <div style={style}>
      <Container {...props}>{children}</Container>
    </div>
  );
}

export default ConstructorContainer;
